(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-timeline"] && !Shopify.designMode) return;
  try {
    
  function initAboutTimelineTrack(track) {
    if (!track) return;
    if (track.dataset.aboutTimelineInitialized === "true") return;
    track.dataset.aboutTimelineInitialized = "true";

    let ticking = false;

    function update() {
      ticking = false;

      const rect = track.getBoundingClientRect();
      const height = Math.max(rect.height, 1);
      const viewportMid = window.innerHeight / 2;

      let progress = (viewportMid - rect.top) / height;
      if (progress < 0) progress = 0;
      if (progress > 1) progress = 1;

      track.style.setProperty("--about-timeline-progress", `${(progress * 100).toFixed(3)}%`);
    }

    function onScrollOrResize() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    update();
    window.addEventListener("scroll", onScrollOrResize, { passive: true });
    window.addEventListener("resize", onScrollOrResize);

    if (typeof ResizeObserver !== "undefined") {
      const ro = new ResizeObserver(onScrollOrResize);
      ro.observe(track);
    }
  }

  function initAllAboutTimelineTracks() {
    const tracks = document.querySelectorAll("[data-about-timeline-track]");
    tracks.forEach((track) => initAboutTimelineTrack(track));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllAboutTimelineTracks);
  } else {
    initAllAboutTimelineTracks();
  }

  document.addEventListener("shopify:section:load", initAllAboutTimelineTracks);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
